<div class="container-fluid">
  <div class="page-head">
    <h5 class="header-title heading-color">EDIT PROFILE - {{displayType}}</h5>
  </div>
  <div class="page-head">
    <h5><a href="javascript:void(0)"><i class="fa fa-arrow-circle-left" (click)="getback()"> BACK
        </i></a>
    </h5>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <form #appointmentForm="ngForm" name="appointmentForm">
            <div class="row">
              <div class="col-12">
                <h6 class="text-center capitalize">ENTER {{displayType}} NAME</h6>
              </div>
            </div><br>
            <form [formGroup]="form">
              <div class="row">
                <div class="col-lg-4 col-md-4"></div>

                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">

                  <input type="text" placeholder="Name" formControlName="name" class="form-control select" #refer />
                  <!-- <datalist id="appointment['pat_name']">
                  <option *ngFor="let pat of patient; let i = index" [ngValue]="pat.pat_name">
                    <div *ngIf="i < 7">
                      {{ pat["f_name"] }} {{ pat["l_name"] }}
                    </div>
                  </option>
                </datalist> -->
                </div>

                <div class="col-lg-4 col-md-4"></div>
              </div>
              <br><br>
              <div class="row">
                <div class="col-12 text-center">
                  <button type="submit" name="find" [disabled]="form.invalid"
                    class="btn btn-primary btn-rounded capitalize" (click)="search()">FIND
                    {{displayType}}</button>
                </div>
              </div>
            </form>
            <br><br><br>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="users && users.length > 0">

    <div class="col-12 col-sm-6 col-md-6 col-lg-4 padleft padright" *ngFor="let user of users">
      <div class="procard">
        <div class="row titlechk">
          <div class="col-8 col-sm-8">
            <h3>{{user?.first_name}} {{user?.last_name}}</h3>
          </div>
          <div *ngIf="!user.pid" class="col-4 col-sm-4">
            <div class="chkwrp">
              <a [routerLink]="['/profile/'+type+'-profile/'+user.u_id]">Edit Profile</a>
            </div>
          </div>
          <div *ngIf="user.pid" class="col-4 col-sm-4">
            <div class="chkwrp">
              <a [routerLink]="['/profile/'+type+'-profile/'+user.pid]">Edit Profile</a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3 col-sm-3">
            <div *ngIf="user.avatarimg !='default_doctor.png' && user.avatarimg !='img_avatar.png'">
              <img [src]="user.ppurl" alt="avatar" class="image">
            </div>
            <div class="profileImage"
              *ngIf="user.avatarimg =='default_doctor.png' || user.avatarimg =='img_avatar.png'">
              <avatar text={{user?.name}} hash={{user?.name}}></avatar>
            </div>
          </div>
          <div class="col-9 col-sm-9">
            <p><label>DOB</label> <span>{{user?.dob | date:'dd-MM-yyyy'}}</span></p>
            <p class="case1" appSearchUser><label>City</label> <span>
                {{user.city_n}} {{user.city}}</span>
            </p>
            <p><label>Contact</label> <span>{{user?.contact_no}}</span></p>
            <p class="case1" appSearchUser><label>Email</label> <span>{{user?.email_id}}</span></p>
            <p *ngIf="user?.gender"><label>Gender</label> <span>{{user?.gender}}</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
<!--end container-->